import { useEffect } from 'react';
import { useCurrentUser } from './auth';
import { setUserIdentity } from './newrelic';

/**
 * Mounts inside <Security> and pushes the resolved user identity into the
 * New Relic Browser agent every time authState changes (initial sign-in,
 * silent renewal, sign-out). Renders nothing.
 *
 * Without this, NR sessions are anonymous and queries like
 *   FROM PageView SELECT * WHERE user.email = '...'
 * return zero rows.
 */
export default function NewRelicIdentity() {
  const { user } = useCurrentUser();

  useEffect(() => {
    setUserIdentity(user);
  }, [user]);

  return null;
}
